// extracted by mini-css-extract-plugin
module.exports = {"wideImage__container":"WideImage-module--wideImage__container--2YPeH","wideImage__content":"WideImage-module--wideImage__content--2Rn2n"};